module.exports = __webpack_public_path__ + "static/img/invest-health3.9e225fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-health3.jpg
// module id = W0Ri
// module chunks = 0